export class Utils {
    static unique (value, index, self) {
      return self.indexOf(value) === index;
    }
  }
